import { FC, SVGProps } from "react";

const CloseIcon: FC<SVGProps<SVGSVGElement>> = ({...props}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentcolor" strokeWidth="2" strokeLinecap="round" stroke="currentcolor" {...props}>
      <path d="M12 4L4 12M4 4L12 12" />
    </svg>
  );
};

export default CloseIcon;
